module.exports = __webpack_public_path__ + "img/contributionOrange.85de866d.png";